import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";
import * as localStorageLib from "../lib/localStorage";

export interface IEnterParam {
    count: number;
}
const localStoragePrefix = "CEnter";
export class VisitsTrigger implements Trigger {
    params: IEnterParam;
    constructor(params: IEnterParam) {
        this.params = params;
    }
    init = (act: Action) => {
        if (
            localStorageLib.getItem(localStoragePrefix, "startDate") == null ||
            localStorageLib.getItem(localStoragePrefix, "startDate").getDate() != new Date().getDate()
        ) {
            localStorageLib.removeItem(localStoragePrefix, "hasRun");
            localStorageLib.setItem(localStoragePrefix, "startDate", new Date());
            localStorageLib.setItem(localStoragePrefix, "EnterCounter", 0);
        } else if (localStorageLib.getItem(localStoragePrefix, "EnterCounter") < this.params.count) {
            var enterCounter = localStorageLib.getItem(localStoragePrefix, "EnterCounter") + 1;
            localStorageLib.setItem(localStoragePrefix, "EnterCounter", enterCounter);
        } else if (
            localStorageLib.getItem(localStoragePrefix, "EnterCounter") == this.params.count &&
            localStorageLib.getItem(localStoragePrefix, "hasRun") == null
        ) {
            act.execute();
            localStorageLib.setItem(localStoragePrefix, "hasRun", true);
        }
    };
}
